import { render, staticRenderFns } from "./intestinal.vue?vue&type=template&id=08058cfc&scoped=true&"
import script from "./intestinal.vue?vue&type=script&lang=js&"
export * from "./intestinal.vue?vue&type=script&lang=js&"
import style0 from "./intestinal.vue?vue&type=style&index=0&id=08058cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08058cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
